import { Component } from 'react';

import { Button } from '@mui/material';

export default class ProjectTitle extends Component {
  constructor(props) {
    super(props);
    
    const item = props.item;
    const title = item.title;
    const link = item.link;
    this.state = {
      title,
      link
    }
  }

  render() {
    const {
      title,
      link
    } = this.state;

    return (
      <Button variant='text' className='project transparent center-block' href={link}>
        {title}
      </Button>
    );
  }
}
